'use client';

type PaginationProps = {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
};

export function Pagination({ currentPage, totalPages, onPageChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <div className="flex justify-center items-center gap-2 py-4 flex-wrap bg-cream mx-[-1rem] px-4 mt-4">
      <button
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
        aria-label="Trang trước"
        className="w-10 h-10 rounded-xl bg-white border border-coral-200 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-coral-50 focus-visible:ring-2 focus-visible:ring-coral-400 focus-visible:ring-offset-2"
      >
        ←
      </button>

      <div className="flex gap-1">
        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
          let pageNum;
          if (totalPages <= 5) pageNum = i + 1;
          else if (currentPage <= 3) pageNum = i + 1;
          else if (currentPage >= totalPages - 2) pageNum = totalPages - 4 + i;
          else pageNum = currentPage - 2 + i;

          return (
            <button
              key={pageNum}
              onClick={() => onPageChange(pageNum)}
              className={`w-10 h-10 rounded-xl focus-visible:ring-2 focus-visible:ring-coral-400 focus-visible:ring-offset-2 ${
                currentPage === pageNum
                  ? 'bg-coral-500 text-white shadow-sm'
                  : 'bg-white border border-coral-200 hover:bg-coral-50'
              }`}
            >
              {pageNum}
            </button>
          );
        })}
      </div>

      <button
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
        aria-label="Trang sau"
        className="w-10 h-10 rounded-xl bg-white border border-coral-200 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-coral-50 focus-visible:ring-2 focus-visible:ring-coral-400 focus-visible:ring-offset-2"
      >
        →
      </button>
    </div>
  );
}
